<template>
  <div class="bg">
    <top-nav title="ZOOM下载"></top-nav>
    <div class="cec-info">
        <img class="absolute-img" src="@/assets/images/cec2022/bird_2.png" style="top: 100px;z-index:-1;"/>
        <div class="buttons">
            <div class="flex">
                <a href="//cdn.edstatic.com/203012120000/15fb87c61cc64c6a87429980fb6667a8/2022/11/4c109a2f-2c38-48b4-9e89-be27871c47af.pdf" target="_blank">
                    <img src="@/assets/images/cec2022/zoom_btn1.png" />
                </a>
                <a href="//cdn.edstatic.com/203012120000/a8bf976181f2a7de476cdccd860cabbb/2022/11/2688d383-9a88-4269-b6ab-6dc5ae0b0ecc.exe" target="_blank">
                    <img src="@/assets/images/cec2022/zoom_btn2.png"/>
                </a>
            </div>
            <div class="flex">
                <a href="//cdn.edstatic.com/203012120000/a54384907d8eda6bf4468e6f40002013/2022/11/ff3f1138-7b68-4b8f-88ac-0fe7664cc392.pkg" target="_blank">
				    <img src="@/assets/images/cec2022/zoom_btn3.png"/>
                </a>
                <a href="//cdn.edstatic.com/203012120000/b79ae9d02713a37468bac258425ff048/2022/11/991fcdf3-19f0-49c2-8fae-bdcd036ae8f2.apk" target="_blank">
                    <img src="@/assets/images/cec2022/zoom_btn4.png"/>
                </a>
            </div>
            <div class="flex">
                <a href="//apps.apple.com/cn/app/zoom-cloud-meetings/id546505307" target="_blank">
                    <img src="@/assets/images/cec2022/zoom_btn5.png"/>
                </a>
                <a href="//cdn.edstatic.com/203012120000/150f4664960c92955bfef44e669abf29/2022/11/eb89b730-9dfc-47c6-94e9-1debeec5791e.pdf" target="_blank">
                    <img src="@/assets/images/cec2022/zoom_btn6.png"/>
                </a>

            </div>
        </div>
    </div>
    <img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/>
  </div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import {ButtonDetail} from '../../config/interface.js'

export default {
    components:{
        topNav
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
     methods:{
            //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			}
    }
}
</script>

<style scoped lang="scss">
.bg{
    background: white;
    margin-top: 48px;
}
.cec-info{
	padding: 20px 15%;
	position: relative;
}
.cec-info img{
	width: 100%;
}
.cec-info .absolute-img{
	position: absolute;
	top:30px;
	left: 0;
}
.cec-info .red-text{
	color: #B2312E;
}
.cec-info .text{
	margin: 10px 0 30px;
	font-size: 13px;
	line-height: 26px;
}
.cec-info .line1{
	line-height: 40px;
}
.cec-info .line1 img{
	width: 20px;
	vertical-align: middle;
	line-height: 40px;
	margin-right: 10px;
}
.cec-info  .buttons{
	margin: 2rem 0;
}
.buttons .flex{
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin: 20px 0;
}
.buttons .flex a{
	width: 43%;
    img{
        width: 100%;
    }
}
.wel-text{
	background-color: #C23231;
	color: white;
	font-size: 13px;
	line-height: 30px;
}
.speaker-words{
	position: relative;
	font-size: 13px;
}
.speaker-words .bottom-icon{
	position: absolute;
	right: 0;
	width: 40px;
}
.text-flex{
	margin: 30px 0 20px;
}
.text-flex img{
	width: 29%;
	float: left;
	margin-right: 10px;
}
.bottom-img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/zoom.vue